module.exports = __webpack_public_path__ + "img/rock-big-11.cfde71e5.png";